import type { translateLayout } from '~/@types/TranslateLayout';

export const useTranslateLayOut = defineStore('translateLayout', () => {
    const translateData = ref<translateLayout>();
    const setTranslate = (translate: translateLayout): translateLayout => (translateData.value = { ...translate });
    return { translateData, setTranslate };
});
